import { render, staticRenderFns } from "./roomJoin.vue?vue&type=template&id=01edadec&lang=pug&"
import script from "./roomJoin.vue?vue&type=script&lang=js&"
export * from "./roomJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports